// 無限スクロール
document.addEventListener('DOMContentLoaded', () => {
  const articles = JSON.parse(document.getElementById('all-articles-json').textContent);
  const container = document.getElementById('block-container');
  const trigger = document.getElementById('infinite-scroll-trigger');

  let currentIndex = 0;
  const initialCount = 12;
  const loadMoreCount = 12;

  function renderArticles(start, count) {
    const slice = articles.slice(start, start + count);
    slice.forEach(article => {
      const div = document.createElement('div');
      div.className = 'aw-coordinate-list';
      div.dataset.articleHandle = article.handle;
      div.dataset.tags = article.tags;
      div.dataset.images = JSON.stringify(article.coordinate_slider_img);
      div.dataset.texts = JSON.stringify(article.coordinate_slider_txt);
      div.dataset.products = JSON.stringify(article.coordinate_product);
      div.dataset.productImages = JSON.stringify(article.coordinate_product_img);

      div.innerHTML = `
        <a class="aw-coordinate-list__mv js-modal-open">
          <div class="aw-coordinate-list__mv_item">
            <img class="lazyload" src="${article.image}" alt="${article.title}">
            <span class="plus">
              <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24.8975" r="24" fill="currentColor"></circle>
              <path d="M33.5037 26.0414H25.1184V34.4266H23.3853V26.0414H15V24.2827H23.3853V15.8975H25.1184V24.2827H33.5037V26.0414Z" fill="white"></path>
              </svg>
            </span>
          </div>
        </>
      `;

      container.appendChild(div);
    });
  }

  // 初期描画
  renderArticles(0, initialCount);
  currentIndex = initialCount;

  // Intersection Observerでロード
  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && currentIndex < articles.length) {
      renderArticles(currentIndex, loadMoreCount);
      currentIndex += loadMoreCount;

      if (currentIndex >= articles.length) {
        observer.unobserve(trigger);
        trigger.remove();
      }
    }
  });

  observer.observe(trigger);
});




// モーダル開閉 + Prev/Next機能
window.addEventListener('load', function() {
  let openBtn = $('.js-modal-open');
  let closeBtn = $('.js-modal-close');
  let modalWrap = $('.aw-coordinate-modal-wrap');
  let modalBox = $('#js-modal-box');
  
  // フィルタリングされた記事リストを保持
  let filteredArticles = [];
  let currentIndex = 0;
  
  // 現在表示されている記事リストを取得
  function getFilteredArticles() {
    let articles = [];
    $('.aw-coordinate-list').each(function() {
      let $article = $(this);
      
      // attr()を使って直接属性を取得
      let handle = $article.attr('data-article-handle');
      let tags = $article.attr('data-tags');
      let imagesAttr = $article.attr('data-images');
      let textsAttr = $article.attr('data-texts');
      let productsAttr = $article.attr('data-products');
      let productImagesAttr = $article.attr('data-product-images');
      
      // JSON文字列をパース
      let images = [];
      let texts = [];
      let products = [];
      let productImages = [];
      
      try {
        if (imagesAttr) images = JSON.parse(imagesAttr);
      } catch(e) {
        console.error('Images parse error:', e);
      }
      
      try {
        if (textsAttr) texts = JSON.parse(textsAttr);
      } catch(e) {
        console.error('Texts parse error:', e);
      }
      
      try {
        if (productsAttr) products = JSON.parse(productsAttr);
      } catch(e) {
        console.error('Products parse error:', e);
      }
      
      try {
        if (productImagesAttr) productImages = JSON.parse(productImagesAttr);
      } catch(e) {
        console.error('Product images parse error:', e);
      }
      
      articles.push({
        handle: handle,
        tags: tags,
        images: images || [],
        texts: texts || [],
        products: products || [],
        productImages: productImages || [],
        element: $article
      });
    });
    return articles;
  }

  // モーダルコンテンツを生成
  function createModalContent(articleData, showPrev, showNext) {
    let images = Array.isArray(articleData.images) ? articleData.images : [];
    let texts = Array.isArray(articleData.texts) ? articleData.texts : [];
    let products = Array.isArray(articleData.products) ? articleData.products : [];
    let productImages = Array.isArray(articleData.productImages) ? articleData.productImages : [];
    
    let sliderHtml = '';
    let thumbsHtml = '';
    console.log('products:',products);
    if (images.length === 0) {
      sliderHtml = '<div class="aw-coordinate-modal__slider-item"><p class="slider_txts">-</p></div>';
      thumbsHtml = '<div class="aw-coordinate-modal__slider-thumbs"></div>';
    } else {
      images.forEach((img, index) => {
        let text = texts[index] || '';
        sliderHtml += `
          <div class="aw-coordinate-modal__slider-item">
            <img src="${img}" alt="Coordinate ${index + 1}" />
            <p class="slider_txts">${text}</p>
          </div>
        `;
        thumbsHtml += `
          <div class="aw-coordinate-modal__slider-thumb">
            <img src="${img}" alt="Coordinate ${index + 1}" />
          </div>
        `;
      });
    }
    
    // 商品リストのHTML生成
    let productsHtml = '';
    if (products.length > 0 ) {
      productsHtml = '<div class="aw-coordinate-modal__products_area"><h2>Worn Items</h2>';
      productsHtml += '<div class="aw-coordinate-modal__products">';

      productImages.forEach((img, index) => {
        // 対応する商品URLを取得（インデックスが一致する場合）
        let productUrl = products[index] ? products[index].url : '#';
        let productTitle = products[index] ? products[index].title : '';
        productsHtml += `
          <div class="aw-coordinate-modal__product">
            <a href="${productUrl}">
              <img src="${img}" alt="Product image ${index + 1}" />
              <p>${productTitle}</p>
            </a>
          </div>
        `;
      });
      productsHtml += '</div>';
      productsHtml += '</div>';
    }
    
    let prevClass = showPrev ? '' : 'disabled';
    let nextClass = showNext ? '' : 'disabled';
    
    return `
      <div id="js-modal-content">
        <div class="aw-coordinate-modal">
          <div class="aw-coordinate-modal__inner">
            <div class="aw-coordinate-modal__slider-wrap">
              <div class="aw-coordinate-modal__slider">
                ${sliderHtml}
              </div>
              <div class="aw-coordinate-modal__slider-thumbs">
                ${thumbsHtml}
              </div>
            </div>
            ${productsHtml}
          </div>

          <div class="aw-coordinate-modal__arrows">
            <a href="#" class="aw-coordinate-modal__arrow aw-coordinate-modal__arrow--next js-slide-btn js-prev-btn ${prevClass}" data-direction="prev">
              <span></span>Prev
            </a>
            <a href="#" class="aw-coordinate-modal__arrow aw-coordinate-modal__arrow--prev js-slide-btn js-next-btn ${nextClass}" data-direction="next">
              Next<span></span>
            </a>
          </div>
        </div>
      </div>
    `;
  }
  
  // モーダルを表示
  function showModal(articleHandle) {
    // 現在のインデックスを見つける
    currentIndex = filteredArticles.findIndex(a => a.handle === articleHandle);
    
    if (currentIndex === -1) return;
    
    let articleData = filteredArticles[currentIndex];
    let showPrev = currentIndex > 0;
    let showNext = currentIndex < filteredArticles.length - 1;
    
    modalBox.stop(true, true).fadeOut(200, function() {
      modalBox.empty();
      let content = createModalContent(articleData, showPrev, showNext);
      modalBox.html(content);
      
      const mainSlider = $(".aw-coordinate-modal__slider");
      const thumbSlider = $(".aw-coordinate-modal__slider-thumbs");
      
      // すべての画像の読み込みが完了するのを待つ
      const images = modalBox.find('img');
      let loadedCount = 0;
      
      if (images.length === 0) {
        initSlick();
      } else {
        images.each(function() {
          if (this.complete) {
            loadedCount++;
            if (loadedCount === images.length) initSlick();
          } else {
            $(this).on('load error', function() {
              loadedCount++;
              if (loadedCount === images.length) initSlick();
            });
          }
        });
      }
      
      function initSlick() {
        if (mainSlider.length && thumbSlider.length && typeof mainSlider.slick === "function") {
          thumbSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: mainSlider,
            focusOnSelect: true,
            swipe: false,
            arrows: false,
            variableWidth: true,
            lazyLoad: "progressive",
            responsive: [{
              breakpoint: 767,
              settings: {}
            }]
          });
          
          mainSlider.slick({
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            infinite: true,
            speed: 500,
            fade: false,
            swipe: true,
            arrows: false,
            variableWidth: false,
            lazyLoad: "progressive",
            asNavFor: thumbSlider,
            responsive: [{
              breakpoint: 767,
              settings: {}
            }]
          });
        }
        
        modalBox.fadeIn(200);
      }
    });
  }

$(document).on('click', '.js-modal-open', function(e) {
    e.preventDefault();
    // 現在フィルタリングされている記事リストを取得
    filteredArticles = getFilteredArticles();
    
    // クリックされた記事のhandleを取得
    let articleHandle = $(this).closest('.aw-coordinate-list').data('article-handle');
    
    showModal(articleHandle);
    modalWrap.addClass('active');
  });
  

  // Prev/Nextボタンのクリック
  $(document).on('click', '.js-slide-btn:not(.disabled)', function(e) {
    e.preventDefault();
    
    let direction = $(this).data('direction');
    
    if (direction === 'prev' && currentIndex > 0) {
      currentIndex--;
      showModal(filteredArticles[currentIndex].handle);
    } else if (direction === 'next' && currentIndex < filteredArticles.length - 1) {
      currentIndex++;
      showModal(filteredArticles[currentIndex].handle);
    }
  });
  
  // モーダルを閉じる
  closeBtn.on('click', function() {
    modalWrap.removeClass('active');
  });
});
